module.exports = __webpack_public_path__ + "img/qy.66e99bdb.png";